import CustomFilterText from "../unit/CustomFilterText";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterDecision from "../unit/FilterDecision";
import FilterProduct from "../unit/FilterProduct";
import FilterVendors from "../unit/FilterVendors";

const vendorsApplicationsFilters = [
  // <CustomFilterText
  //   label="Referral"
  //   source="vendor_name"
  //   defaultValue=""
  //   alwaysOn
  // />,
  <FilterVendors
    label="Referral Source"
    source="vendor_name"
    defaultValue=""
    alwaysOn
  />,
  <CustomFilterText label="App #" source="iId" defaultValue="" />,
  <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
  <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterProduct label="Product" source="sProductName" before="and" />,
  <FilterDecision label="Decision" source="sReview" before="and" />,
];

export default vendorsApplicationsFilters;
